import React from 'react';
import { Link } from 'react-router-dom';
import { User, LogOut, ChevronDown } from 'lucide-react';
import { Button } from '../ui/button';

/**
 * Desktop "Ecosystem" hover dropdown (includes the user/sign-in submenu at the bottom).
 * Pure presentation.
 */
const EcosystemMenu = ({
  ecosystemItems,
  isActive,
  isEcosystemActive,
  customerUser,
  investorUser,
  onLogout,
}) => {
  return (
    <div className="relative group">
      <Button
        variant="ghost"
        className={`${
          isEcosystemActive
            ? 'bg-green-50 text-green-700 font-semibold'
            : 'text-gray-700 hover:text-green-700 hover:bg-green-50'
        } transition-all duration-300 flex items-center gap-1`}
      >
        Ecosystem
        <ChevronDown className="h-3.5 w-3.5 transition-transform group-hover:rotate-180" />
      </Button>
      <div className="absolute top-full left-0 mt-1 w-52 bg-white rounded-lg shadow-xl border border-gray-100 py-1 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
        {ecosystemItems.map((item) => (
          <Link key={item.path} to={item.path} className="block">
            <div className={`px-4 py-2.5 text-sm transition-colors ${
              isActive(item.path) ? 'bg-green-50 text-green-700 font-medium' : 'text-gray-700 hover:bg-green-50 hover:text-green-700'
            }`}>
              {item.label}
            </div>
          </Link>
        ))}
        <div className="border-t border-gray-100 mt-1 pt-1">
          {customerUser || investorUser ? (
            <>
              <Link to={investorUser ? '/investor/dashboard' : '/account'} className="block">
                <div className="px-4 py-2.5 text-sm text-gray-700 hover:bg-green-50 hover:text-green-700 flex items-center gap-2">
                  <User className="h-4 w-4" /> My Dashboard
                </div>
              </Link>
              <button onClick={onLogout} className="w-full text-left">
                <div className="px-4 py-2.5 text-sm text-red-600 hover:bg-red-50 rounded-b-lg flex items-center gap-2">
                  <LogOut className="h-4 w-4" /> Sign Out
                </div>
              </button>
            </>
          ) : (
            <Link to="/auth" className="block">
              <div className="px-4 py-2.5 text-sm text-gray-700 hover:bg-green-50 hover:text-green-700 rounded-b-lg flex items-center gap-2">
                <User className="h-4 w-4" /> Sign In / Sign Up
              </div>
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default EcosystemMenu;
